import axios from "axios";
import { API } from "./api";

const KEY = "nl_member_token";
const mapi = axios.create({ baseURL: API });
mapi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const hasMemberToken = () => !!localStorage.getItem(KEY);
export const memberSignOut = () => localStorage.removeItem(KEY);
const keep = (r) => { localStorage.setItem(KEY, r.data.token); return r.data.member; };

export const memberRegister = (d) => mapi.post("/members/register", d).then(keep);
export const memberLogin = (email, password) => mapi.post("/members/login", { email, password }).then(keep);
export const memberMe = () => mapi.get("/members/me").then((r) => r.data);
export const memberClaims = () => mapi.get("/members/claims").then((r) => r.data);
export const claimOffer = (offer_id) => mapi.post("/members/claim", { offer_id }).then((r) => r.data);
export const getLoyaltyOffers = () => mapi.get("/loyalty/offers").then((r) => r.data);
export const getLoyaltyMerchants = () => mapi.get("/loyalty/merchants").then((r) => r.data);

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.some((x) => String(x?.loc || "").includes("email")) ? "Please enter a valid email address." : "Please check the form and try again.";
  return String(d);
};
